// extracted by mini-css-extract-plugin
export var columnCard = "structured-text-report-module--columnCard--2139e";
export var columnCardImage = "structured-text-report-module--columnCardImage--c74bf";
export var columnCardText = "structured-text-report-module--columnCardText--d957b";
export var columnCardTitle = "structured-text-report-module--columnCardTitle--7f88e";
export var content = "structured-text-report-module--content--6affa";
export var headerCard = "structured-text-report-module--headerCard--88601";
export var number = "structured-text-report-module--number--5e48f";
export var tableContent = "structured-text-report-module--tableContent--d2890";
export var title = "structured-text-report-module--title--01b93";